// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"WishlistIcon_Wrapper__fBG7h","WishListHeart":"WishlistIcon_WishListHeart__tbOX4","WishlistedHeart":"WishlistIcon_WishlistedHeart__pQPM9"};